import React from "react";
import { orderOperationsDapLast } from "../lib/operationOrder";
import "./OperationDapOrder.css";

export default function OperationDapOrder({ operations, children }) {
  const ordered = orderOperationsDapLast(operations);
  return ordered.map((operation, index) => (
    <React.Fragment key={operation._id ?? index}>
      {operation.dap === true && (index === 0 || ordered[index - 1].dap !== true) && (
        <div className="operation-dap-separator" role="separator" aria-label="Operaciones D.A.P">
          <span>D.A.P</span>
        </div>
      )}
      {children(operation)}
    </React.Fragment>
  ));
}
